import { InjectionToken } from '@angular/core';
import { ControlService } from '@shared/services/control.service';

export const CONTROL_SERVICE_PROVIDER = new InjectionToken<ControlService>(
  'control-service-provider',
);
